import { createSlice } from "@reduxjs/toolkit";
import * as ProjectActions from "./actions";
import {append, assoc, dissoc, lensProp, pathOr, pipe, propOr, set} from "ramda";
import {roundUpCoordinate} from "../../helpers/common";
import * as AppActions from "../app/actions";

export const initialState = {
  draftingObject: null,
  testResultUrl: null,
  togglePreview: false,
  jsonTemplateData: null,
  entities: {},
  ids: []
};

const projectSlice = createSlice({
  name: "PDFViewer",
  initialState,
  reducers: {},
  extraReducers: {
    [AppActions.resetAppState.type]: (state, action) => {
      return initialState;
    },
    [ProjectActions.clearAllObjectsProject.type]: (state, action) => {
      return pipe(
        set(lensProp("entities"), {}),
        set(lensProp("ids"), []),
      )(state);
    },

    [ProjectActions.setDraftingObject.type]: (state, action) => {
      return pipe(
        set(lensProp("draftingObject"), pathOr(null, ["payload", "data"], action))
      )(state);
    },

    [ProjectActions.togglePreviewFunc.type]: (state, action) => {
      return pipe(
        set(lensProp("togglePreview"), pathOr(null, ["payload", "data"], action))
      )(state);
    },

    [ProjectActions.setTestResultUrl.type]: (state, action) => {
      return pipe(
        set(lensProp("testResultUrl"), pathOr(null, ["payload", "url"], action))
      )(state);
    },

    [ProjectActions.setJsonTemplateData.type]: (state, action) => {
      return pipe(
        set(lensProp("jsonTemplateData"), pathOr(null, ["payload", "jsonTemplateData"], action))
      )(state);
    },

    [ProjectActions.addObjectToProject.type]: (state, action) => {
      const data = pathOr(null, ["payload", "data"], action);
      const entities = state.entities;
      const ids = state.ids;
      return pipe(
        set(lensProp("entities"), assoc(data.objectId, data, entities)),
        set(lensProp("ids"), append(data.objectId, ids)),
      )(state);
    },

    [ProjectActions.addObjectsFromTemplate.type]: (state, action) => {
      const data = pathOr(null, ["payload", "data"], action);
      return pipe(
        set(lensProp("entities"), pathOr({}, ['entities', 'projects'], data)),
        set(lensProp("ids"), propOr([], 'result', data)),
      )(state);
    },

    [ProjectActions.updateObjectProject.type]: (state, action) => {
      const data = pathOr(null, ["payload", "data"], action);
      const id = pathOr(null, ["payload", "data", 'objectId'], action);
      const entities = state.entities;

      return pipe(
        set(lensProp("entities"), set(lensProp(id), data, entities)),
      )(state);
    },

    [ProjectActions.removeObjectProject.type]: (state, action) => {
      const id = pathOr(null, ["payload", "id"], action);
      const entities = state.entities;
      const ids = state.ids;
      return pipe(
        set(lensProp("entities"), dissoc(id, entities)),
        set(lensProp("ids"), ids.filter((item) => item !== id)),
      )(state);
    },

    [ProjectActions.changeProjectObjectCoordinates.type]: (state, action) => {
      const payload = pathOr(null, ["payload"], action);
      const newData = {
        ...state.entities[payload.id],
        x: roundUpCoordinate(payload.x),
        y: roundUpCoordinate(payload.y)
      }
      const newEntities = set(lensProp(payload.id), newData)(state.entities)

      return pipe(
        set(lensProp("entities"), newEntities),
      )(state);
    },

    [ProjectActions.changeProjectObjectSizes.type]: (state, action) => {
      const payload = pathOr(null, ["payload"], action);
      const newData = {
        ...state.entities[payload.id],
        width: roundUpCoordinate(payload.w),
        height: roundUpCoordinate(payload.h)
      }
      const newEntities = set(lensProp(payload.id), newData)(state.entities)

      return pipe(
        set(lensProp("entities"), newEntities),
      )(state);
    }
  }
});

export const { actions, reducer, name: sliceKey } = projectSlice;
